import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { Vehicle } from '../../types/vehicle.types'

export type VehicleState = {
  current?: Vehicle
}

const CURRENT_VEHICLE_STORAGE_KEY = 'f3.currentVehicle'

const loadPersistedVehicle = (): Vehicle | undefined => {
  if (typeof window === 'undefined') return undefined

  const persistedVehicleJson = window.localStorage.getItem(CURRENT_VEHICLE_STORAGE_KEY)
  if (!persistedVehicleJson) return undefined

  try {
    const persistedVehicle = JSON.parse(persistedVehicleJson) as Partial<Vehicle>
    if (
      typeof persistedVehicle.vin !== 'string' ||
      typeof persistedVehicle.modelName !== 'string'
    ) {
      return undefined
    }

    return {
      vin: persistedVehicle.vin,
      modelName: persistedVehicle.modelName,
      imageUrl: persistedVehicle.imageUrl ?? null,
      consentId: persistedVehicle.consentId,
    }
  } catch {
    return undefined
  }
}

const persistVehicle = (vehicle: Vehicle) => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(CURRENT_VEHICLE_STORAGE_KEY, JSON.stringify(vehicle))
}

const initialState: VehicleState = {
  current: loadPersistedVehicle(),
}

const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {
    setCurrentVehicle(state, action: PayloadAction<Vehicle>) {
      state.current = action.payload
      persistVehicle(action.payload)
    },
  },
})

export const { setCurrentVehicle } = vehicleSlice.actions
export const vehicleReducer = vehicleSlice.reducer
